import { render, staticRenderFns } from "./CreatePlanTierOverrides.vue?vue&type=template&id=25203e18&scoped=true&"
import script from "./CreatePlanTierOverrides.vue?vue&type=script&lang=js&"
export * from "./CreatePlanTierOverrides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25203e18",
  null
  
)

export default component.exports